import { configureStore } from '@reduxjs/toolkit';
import DrawReducer from './drawSlice';
import TaskReducer from './taskSlice';
import BoardReducer from './boardSlice';
import StyleReducer from './styleSlice';
import UserReducer from './userSlice';
import MemberReducer from './memberSlice';
import AlbumReducer from './albumSlice';
import WaterdropReducer from './waterdropSlice';

export type RootState = {
    draw: ReturnType<typeof DrawReducer>;
    task: ReturnType<typeof TaskReducer>;
    board: ReturnType<typeof BoardReducer>;
    style: ReturnType<typeof StyleReducer>;
    user: ReturnType<typeof UserReducer>;
    member: ReturnType<typeof MemberReducer>;
    album: ReturnType<typeof AlbumReducer>;
    waterdrop: ReturnType<typeof WaterdropReducer>;
};

export const store = configureStore({
    reducer: {
        draw: DrawReducer,
        task: TaskReducer,
        board: BoardReducer,
        style: StyleReducer,
        user: UserReducer,
        member: MemberReducer,
        album: AlbumReducer,
        waterdrop: WaterdropReducer,
    }
});

export type AppDispatch = typeof store.dispatch;
